<template>
    <div id="counselBox">
        <img src="https://htmlqiniu.jihex.com/saas/mobile/counselQrCode.png" alt="" />
    </div>
</template>

<script>
export default {
    name: 'WebsiteCounsel',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
#counselBox{
    background-color: #F7F9FC;
    height: 100vh;
    img{
        margin-top: .76rem;
        width: 7.5rem;
        vertical-align: top;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/counsel.vue